import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <Navbar/>
      <section className="pt-40 pb-20 px-6 md:px-12 max-w-5xl mx-auto">
        <p className="eyebrow mb-3">About</p>
        <h1 className="font-serif text-5xl md:text-7xl mb-2">My name is <span className="italic gradient-gold">Onianto.</span></h1>
        <div className="divider"/>
        <div className="grid md:grid-cols-2 gap-12 mt-12 items-start">
          <div className="aspect-[3/4] overflow-hidden rounded-lg bg-[#0c1825] flex items-center justify-center">
            <img src="/images/onianto.jpg" className="w-full h-full object-contain" alt="Onianto"/>
          </div>
          <div className="space-y-6 text-[#b8c5d1] leading-relaxed">
            <p>Founded by a proud Jamaican entrepreneur, our elite transportation service was built on a simple vision: to combine world-class professionalism with the warmth, flair, and vibrance of the Caribbean. With every ride, we deliver not just luxury, but an experience — seamlessly blending premium service with authentic personality.</p>
            <p>From airport transfers to corporate travel and special celebrations, we ensure our guests feel both pampered and welcomed, as if every journey were a taste of the islands. More than just transportation, we provide a refined, memorable experience where comfort, reliability and Caribbean charm ride together.</p>
            <p className="italic text-[#5DCFE5]">At the heart of our brand is a promise: professionalism with personality. Every client is treated like family, every ride is tailored with care, and every moment carries that unique island-inspired touch.</p>
            <Link to="/book" className="btn-gold mt-4">Book Your Experience <ArrowRight size={16}/></Link>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
}
